import {h, Fragment} from "preact"
import { useProductFilters } from '@nosto/preact'

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <ul class="no-bullets tag-list tag-list--active-tags">
                {filters.map((filter) => (
                    <li
                        key={`${filter.name}: ${filter.value}`}
                        class="tag tag--remove"
                        onClick={() => filter.remove()}>
                        <a class="btn btn--small" title={filter.name}>
                            {filter.value}
                        </a>
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            role="presentation"
                            class="icon icon-close"
                            viewBox="0 0 64 64">
                            <path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path>
                        </svg>
                    </li>
                ))}
            </ul>
        )
    )
}
